import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFunnelStore = defineStore(
  'funnel',
  () => {
    const activeSave = ref(false);
    const activePublish = ref(false);
    const funnelData = ref<any>({})
    const allowSave = ref(false)
    const allowPublish = ref(false)
    const upsellResetRequestId = ref(0)
    const upsellRefreshRequestId = ref(0)
    const updateSaveState = (val: boolean) => {
      activeSave.value = val
    }
    const updatePublishState = (val: boolean) => {
      activePublish.value = val;
    };

    const updateFunnelData = (val: any) => {
      funnelData.value = val
    }

    const updateAllowSave = (val: boolean) => {
      allowSave.value = val
    }

    const updateAllowPublish = (val: boolean) => {
      allowPublish.value = val
    }

    // header 重置按钮
    const requestUpsellReset = () => {
      upsellResetRequestId.value += 1
    }
    // header 刷新按钮
    const requestUpsellRefresh = () => {
      upsellRefreshRequestId.value += 1
    }

    return {
      activeSave,
      activePublish,
      funnelData,
      allowSave,
      allowPublish,
      upsellResetRequestId,
      upsellRefreshRequestId,
      updateSaveState,
      updatePublishState,
      updateFunnelData,
      updateAllowSave,
      updateAllowPublish,
      requestUpsellReset,
      requestUpsellRefresh,
    };
  },
  {
    persist: {
      omit: ['upsellResetRequestId', 'upsellRefreshRequestId'],
    },
  }
)
